import { useEffect } from 'react'

import { type SelectDatasource } from '@loadsmart/loadsmart-ui/dist/components/Select/Select.types'

import { useAsync } from 'core/ui/hooks/useAsync'

import { getTractorsNumbers } from '../../use-cases/getTractorsNumbers'

export type SelectTractor = {
  _type: string
  label: string
  value: string
  source?: string
}

export function useGetCarrierTractorsDatasource(carrierUUID: string) {
  return function dataSource(): SelectDatasource<SelectTractor> {
    return {
      type: 'tractor',
      adapter: {
        getKey: tractor => tractor.value,
        getLabel: tractor => tractor.label,
      },
      async fetch({ query }) {
        if (!query) {
          return []
        }

        try {
          const result = await getTractorsNumbers({
            carrierUUID,
            query,
          })
          return result.map(tractor => ({
            _type: 'tractor',
            value: tractor.tractorNumber,
            label: tractor.tractorNumber,
            source: tractor.tractorNumberSource,
          }))
        } catch (error) {
          return []
        }
      },
    }
  }
}

export function useGetCarrierTractors(carrierUUID: string) {
  const { call, result, status } = useAsync(getTractorsNumbers)

  useEffect(() => {
    call({ carrierUUID })
  }, [carrierUUID, call])

  return { tractors: result, fetchTractors: call, requestStatus: status }
}
